import axiosClient from "./axiosClient";

export const listarPorMes = (mes, anio) =>
  axiosClient.get("/cobros-familia/mes", { params: { mes, anio } }).then((r) => r.data);

export const obtenerDetalle = (cobroId) =>
  axiosClient.get(`/cobros-familia/${cobroId}/detalle`).then((r) => r.data);

export const registrarCobro = (data) =>
  axiosClient.post("/cobros-familia", data).then((r) => r.data);

export const amortizar = (cobroId, monto) =>
  axiosClient.post(`/cobros-familia/${cobroId}/amortizar`, { monto }).then((r) => r.data);

export const cancelar = (cobroId) =>
  axiosClient.post(`/cobros-familia/${cobroId}/cancelar`).then((r) => r.data);

export const eliminar = (cobroId) =>
  axiosClient.delete(`/cobros-familia/${cobroId}`).then((r) => r.data);

export const cambiarEstado = (cobroId, nuevoEstado) =>
  axiosClient.post(`/cobros-familia/${cobroId}/estado`, { nuevoEstado }).then((r) => r.data);

export const extornar = (cobroId) =>
  axiosClient.post(`/cobros-familia/${cobroId}/extornar`).then((r) => r.data);

export const cancelarTodosPorDeudor = (deudorId, mes, anio) =>
  axiosClient.post(`/cobros-familia/deudor/${deudorId}/cancelar-todo`, null, { params: { mes, anio } }).then((r) => r.data);

export const liquidarTodosPorDeudor = (deudorId, mes, anio) =>
  axiosClient.post(`/cobros-familia/deudor/${deudorId}/liquidar-todo`, null, { params: { mes, anio } }).then((r) => r.data);

export const listarGastosDisponibles = (cuentaId, mes, anio) =>
  axiosClient.get("/cobros-familia/gastos-disponibles", { params: { cuentaId, mes, anio } }).then((r) => r.data);

export const obtenerReporte = (mes, anio) =>
  axiosClient.get("/cobros-familia/reporte", { params: { mes, anio } }).then((r) => r.data);

export const listarDeudores = () =>
  axiosClient.get("/cobros-familia/deudores").then((r) => r.data);

export const crearDeudor = (nombre) =>
  axiosClient.post("/cobros-familia/deudores", { nombre }).then((r) => r.data);
